import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lots: [],
};

const franchise = createSlice({
  name: 'franchise',
  initialState,
  reducers: {
    setFranchise: (_, { payload }) => ({ ...payload }),
    updateFranchise: (state, { payload }) => ({ ...state, ...payload }),
    resetFranchise: (_, { payload }) => ({ ...initialState, ...payload }),
  },
});

export const { setFranchise, updateFranchise, resetFranchise } = franchise.actions;
export default franchise.reducer;
